import { useBodyLock } from '@app/utils/hooks/useBodyLock';
import { isNull } from '@app/utils/is';
import React from 'react';

interface Context {
  containerRef: React.RefObject<HTMLDivElement>;
  isOpen: boolean;
  shouldCloseOnEsc: boolean;
  onClose?: () => void;
  contentRef?: React.RefObject<HTMLDivElement>;
}

export const useModalContext = (): Context => {
  const context = React.useContext(ModalContext);
  if (isNull(context)) {
    throw new Error('ModalContext can not be used outside the scope of ModalContextProvider');
  }

  return context;
};

const ModalContext = React.createContext<Context | null>(null);
interface ModalContextProviderProps {
  isOpen: boolean;
  shouldCloseOnEsc: boolean;
  onClose?: () => void;
  contentRef?: React.RefObject<HTMLDivElement>;
}

export const ModalContextProvider = ({
  children,
  shouldCloseOnEsc,
  isOpen,
  onClose,
  contentRef,
}: React.WithChildren<ModalContextProviderProps>) => {
  const containerRef = React.useRef<HTMLDivElement>(null);

  useBodyLock(isOpen);

  return (
    <ModalContext.Provider
      value={{
        containerRef,
        contentRef,
        isOpen,
        onClose,
        shouldCloseOnEsc,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};
